import { useSelector } from '/druid/internal/WebChatReduxContext';

export default function useReferenceGrammarID(): [string] {
  return [useSelector(({ referenceGrammarID }) => referenceGrammarID)];
}
